module.exports = __webpack_public_path__ + "static/img-26-9a7fbd30328cb63c745c35a0f87e13c4.jpeg";